module.exports = __webpack_public_path__ + "static/media/SLIDERS-CR-600.243dbe8a.png";